export default "__VITE_PUBLIC_ASSET__e08ae483__"